
interface CTAProps {
  onContactClick: () => void;
}

export default function CTA({ onContactClick }: CTAProps) {
  return (
    <section className="relative py-32 bg-zinc-950 overflow-hidden">
      {/* Decorative Background Orbs */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-600/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-red-600/10 rounded-full blur-3xl"></div>
      
      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
          Ready to Bring the Magic to Your Campus?
        </h2>
        <p className="text-xl text-zinc-400 mb-12 max-w-2xl mx-auto">
          Book Thomas for your next campus event and give your students an unforgettable experience they'll be talking about all semester.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={onContactClick}
            className="px-8 py-4 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Bring Thomas to Your Campus
          </button>
          <button
            onClick={onContactClick}
            className="px-8 py-4 bg-transparent border-2 border-red-600 text-red-600 font-semibold rounded-lg hover:bg-red-600 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Check Available Dates
          </button>
        </div>
      </div>
    </section>
  );
}
